import store from '@/store'

const apiErrorHandler = (error) => {
    const {status} = error
    const {name} = error.data.message

    const {urls} = store.state

    if (name == 'TokenExpiredError') {
        return window.location.href = `${urls.CLIENT}/`
    }

    switch(status) {
        case 400: {
            return window.location.href = `${urls.MARKETPLACE}/403`;
        }
        case 401: {
            return window.location.href = `${urls.MARKETPLACE}/403`;
        }
        case 403: {
            return window.location.href = `${urls.MARKETPLACE}/403`;
        }
        case 404: {
            return window.location.href = `${urls.MARKETPLACE}/404`;
        }
        default: {
            return window.location.href = `${urls.MARKETPLACE}/500`;
        }
    }
}

export default apiErrorHandler
